import { render, staticRenderFns } from "./ButtonComissions.vue?vue&type=template&id=1a6dabcf&scoped=true&"
import script from "./ButtonComissions.vue?vue&type=script&lang=ts&"
export * from "./ButtonComissions.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonComissions.vue?vue&type=style&index=0&id=1a6dabcf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6dabcf",
  null
  
)

export default component.exports